<template lang="pug">
div
  FileuploadDropzone(
    v-show="!successfilesCountReached"
    @before-upload="onBeforeUpload"
    ref="dropzone"
    :multiple="true"
    :fileLimit="props.maxFiles"

    :auto="false"
    :disabled="browseDisabled"
    @select="onFileSelect"
    name="filecontents[]"
    :accept="accept"
    :maxFileSize="maxFileSize"
    :url="fileUploadUrl"
    )


  template(v-if="selectedFiles.length > 0")
    h3 {{$t('Выбранные файлы')}}
    template(v-if="props.maxFiles > 0")
      div.maxfiles-warning {{$t('files_uploaded_hint', {max: props.maxFiles, uploaded: successUploadedCount})}}
    .uploaded-files-wrapper
      .uploaded-files
        template(v-for="(selFile, idx) in selectedFiles")
          SingleFileuploadItem(:file="selFile.origFile"
            :key="'file-uploader-' + selFile.listid"
            @before-upload="onBeforeUpload"
            :meta="{listid: selFile.listid}"
            @upload="onSingleFileUpload"
            :auto="true"
            :accept="accept"
            :maxFileSize="maxFileSize"
            @upload-start="onFileUploadStart"
            @error="onSingleFileUploadError"
            name="filecontents[]"
            :url="fileUploadUrl")
            template(#default="slotProps")
              .uploaded-file-wrapper
                template(v-if="slotProps.success")
                  .uploaded-file--success
                    InlineSvg(:src="require('./success-icon.svg')" width="2rem" height="2rem")
                selected-document-file(:file="selFile")
                template(v-if="selFile.uploading")
                  .uploaded-file--uploading {{$t('Идет загрузка')}} ({{slotProps.progress}}%)...
                template(v-if="slotProps.success || slotProps.error")
                  .uploaded-file-controls
                    .btn.btn-danger.btn-sm(@click.prevent="removeFile(selFile.listid)" :disabled="disabled") {{$t('Удалить')}}
                template(v-if="slotProps.error")
                  .uploaded-file-error
                    span {{$t('Ошибка')}}: {{slotProps.errorMessage}}


</template>

<script lang="ts" setup>
import {computed, reactive, ref} from "vue";
import {defineProps, defineEmits} from "vue";
import {RemoteRequestState} from "capitalist-shared/src/core/remote";
import FileuploadDropzone from "@/components/forms/files/FileuploadDropzone.vue";
import SingleFileuploadItem from "@/components/forms/files/SingleFileuploadItem.vue";
import SelectedDocumentFile from "@/components/forms/files/SelectedDocumentFile.vue";
import InlineSvg from "vue-inline-svg";

const props = defineProps({
  value: {
    type: Array,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  checkDuples: {
    type: Boolean,
    default: false,
  },
  maxFileSize: {
    type: Number,
    default: 10485760,
  },
  accept: {
    type: String,
    default: 'application/pdf,image/jpeg,image/png',
  },
  fileUploadUrl: {
    type: String,
    default: '/webapi/finance/incomingwire?call=uploadFile&m[name]=filecontents',
  },
  maxFiles: {
    default: 10,
    type: Number
  }
})

const dropzone = ref(null)

const uploadingStatus = reactive(new RemoteRequestState())
const fileUpload = ref(null)
const fileUploadBusy = computed(() => uploadingStatus.isLoading)
const emit = defineEmits(['update:value', 'input', 'upload-start', 'upload-end'])

const filesUnderUpload = ref([])

const browseDisabled = computed(() => {
  return props.disabled || filesCountReached.value ;
})

// const onFileUpload = (event) => {
//   uploadingStatus.loadEnd()
//   const fileData = JSON.parse(event.xhr.response)
//   emit('upload-end', fileData)
//   // console.log('onUpload: ', event, event.xhr, event.files);
//   // console.log('response: ', fileData);
//   valueFiles.value.splice(valueFiles.value.length, 0, ...fileData);
//
//   //debugger
//   const filesIds = fileData.map((file) => convertCapitalistFileToOurFile(file).fileid)
//
//   // console.log('filter ids', filesIds)
//   filesUnderUpload.value = filesUnderUpload.value.filter((f) => {
//     return filesIds.indexOf(f.id) == -1;
//   })
// }

const onSingleFileUpload = (event) => {
  console.log('onSingleFileUpload', event);
  const fileData = JSON.parse(event.xhr.response)
  const tempFileId = event.meta.listid;

  if (tempFileId !== null) {
    const idx = selectedFiles.value.findIndex((f) => {
      return f.listid == tempFileId;
    });
    if (idx >= 0)
    {
      selectedFiles.value[idx].id = fileData[0].id;
      selectedFiles.value[idx].uploaded = true;
      selectedFiles.value[idx].uploading = false;
    }
  }

  const fd = fileData.map((f) => ({...f, listid: tempFileId}));
  valueFiles.value.splice(valueFiles.value.length, 0, ...fd);

  //debugger
  // const filesIds = fileData.map((file) => convertCapitalistFileToOurFile(file).fileid)

  // console.log('filter ids', filesIds)
  filesUnderUpload.value = filesUnderUpload.value.filter((f) => {
    return f.listid !== tempFileId;
  })

  uploadingStatus.loadEnd();
}


const onFileSelect = ({originalEvent, files}) => {
  // console.log('onFileSelect', files);
  const res = files.map((file) => {
    return convertBrowserFileToOurFile(file)
  })
  const existFileIds = selectedFiles.value.filter((f) => f.uploaded || f.uploading).map((f) => f.fileid);
  res.forEach((el) => {
    if (!props.checkDuples || (existFileIds.indexOf(el.fileid) < 0))
      selectedFiles.value.push(el);
  })
  dropzone.value.clear();
  ///selectedFiles.value.splice(selectedFiles.value.length,0, ...res);
}

const onSingleFileUploadError = (event) => {
  const response = JSON.parse(event.xhr.response)
  emit('upload-end', null, response)

  filesUnderUpload.value = filesUnderUpload.value.filter((f) => {
    return f.listid !== event.meta.listid;
  })

  console.log('onSingleFileUploadError', event)

  selectedFiles.value.forEach((file, idx) => {
    if (file.listid == event.meta.listid) {
      selectedFiles.value[idx].uploading = false;
      selectedFiles.value[idx].uploaded = false;
      selectedFiles.value[idx].error = true;
    }
  })

  uploadingStatus.loadError()
}


const uuidv4 = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    // eslint-disable-next-line no-mixed-operators
    const r = Math.random() * 16 | 0, v = c === 'x' ? r : r & 0x3 | 0x8
    return v.toString(16)
  })
}

const convertBrowserFileToOurFile = (file) => {
  return {
    id: '',
    listid: uuidv4(),
    filename: file.name,
    mimetype: file.type,
    name: file.name,
    size: file.size,
    type: file.type,
    fileid: [file.name, file.size, file.type].join(':'),
    origFile: file,
    uploaded: false,
    uploading: false,
    error: false
  }
}

const convertCapitalistFileToOurFile = (file) => {
  return {
    filename: file.filename,
    mimetype: file.mimetype,
    name: file.filename,
    size: file.size,
    type: file.mimetype,
    fileid: [file.filename, file.size, file.mimetype].join(':')
  }
}


const onFileUploadStart = (data) => {
  const file = selectedFiles.value.find((f) => f.listid == data.meta.listid);
  if (file) {
    filesUnderUpload.value.splice(filesUnderUpload.value.length, 0, file);
  }
  // console.log('onFilesUploadStart', data.files.map((file) => convertBrowserFileToOurFile(file)))
}


const onBeforeUpload = (event) => {
  uploadingStatus.loadStart()
  selectedFiles.value.findIndex((file) => {
    if (file.listid == event.meta.listid) {
      file.uploading = true;
      file.uploaded = false;
    }
  })
  emit('upload-start')
  // console.log('onBeforeUpload: ', event);
}

const valueFiles = computed({
  get: () => props.value,
  set: (value) => {
    emit('update:value', value)
    emit('input', value)
  },
})

const filesCountReached = computed(() => {
  return props.maxFiles > 0
    && (successUploadedCount.value + inprocessUploadingCount.value) >= props.maxFiles;
})

const successfilesCountReached = computed(() => {
  return props.maxFiles > 0
    && (successUploadedCount.value) >= props.maxFiles;
})

const inprocessUploadingCount = computed(() => {
  return filesUnderUpload.value.length;
})

const successUploadedCount = computed(() => {
  return selectedFiles.value.filter((file) => file.uploaded).length;
})

// const combinedFiles = computed(() => {
//   const result = [
//     // ...valueFiles.value.map((file) => {
//     //   return Object.assign(convertCapitalistFileToOurFile(file), {
//     //     uploaded: true,
//     //     uploading: false
//     //   })
//     // }),
//     ...selectedFiles.value.map((file) => {
//       return Object.assign(file, {
//         //uploaded: false,
//         uploading: isFileUploading(file)
//       })
//     })];
//   //
//   // selectedFiles.value.map((file) => {
//   //   return Object.assign(file, {
//   //     uploaded: false,
//   //     uploading: isFileUploading(file)
//   //   })
//   // })
//
//   return result;
//   // selectedFiles.value
//   // filesUnderUpload
// })

const isFileUploading = (file) => {
  return filesUnderUpload.value.findIndex((f) => {
    return f.id == file.listid;
  }) >= 0;
}

const selectedFiles = ref([])

const busy = computed(() => uploadingStatus.isLoading)

const removeFile = (id) => {
  if (props.disabled)
    return;
  // console.log('removeFile', id, valueFiles.value, selectedFiles.value);
  let idx = selectedFiles.value.findIndex((file) => file.listid == id)
  if (idx >= 0) selectedFiles.value.splice(idx, 1);
  idx = valueFiles.value.findIndex((file) => file.listid == id);
  if (idx >= 0) valueFiles.value.splice(idx, 1);
  idx = filesUnderUpload.value.findIndex((file) => file.listid == id);
  if (idx >= 0) filesUnderUpload.value.splice(idx, 1);
  //valueFiles.value = valueFiles.value.filter((file) => file.id != id);
  // const idx = valueFiles.value.findIndex((file) => file.id == id);
  // if (idx >= 0)
  //     valueFiles.value.splice(idx, 1)
  //selectedFiles.value.splice(selectIndex, 1)
}

const clear = () => {
  selectedFiles.value.splice(0);
  valueFiles.value.splice(0);
  dropzone.value.clear();
}

defineExpose({
  uploadingStatus,
  filesUnderUpload,
  busy,
  clear,
})
</script>

<style scoped lang="less">
.my-header {
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
}
.pb-uploading {
  width: 120px;
}
.dropzone {
  i.pi {
    font-size: 3rem;
  }
}

::v-deep {
  .p-fileupload {
    .p-fileupload-buttonbar {
      .p-button {
        font-size: 1.4rem;
      }
      .p-button.p-fileupload-choose.p-focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem rgb(7, 128, 7);
      }

      .p-fileupload-choose {
        background: #80bd1c;
        border: 1px solid #80bd1c;

        &:focus, &:focus-visible, &.p-focus {
          outline: 0 none;
          outline-offset: 0;
          box-shadow: 0 0 0 0.2rem rgb(7, 128, 7);
        }
      }
    }
  }

}

.uploaded-files-wrapper {
  padding: 1.5rem 0 1.5rem 1.5rem;

  .uploaded-file--success {
    position: absolute;
    right: 1.5rem;
    top: 1.5rem;
    svg {
      color: #80bd1c;
      fill: #80bd1c;
      transition: opacity 0.5s;
      opacity: 0.6;
    }
  }
}
.no-files {
  min-height: 20rem;
}

.uploaded-files {
  min-height: 20rem;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;

  --gap: 1.5rem;
  display: inline-flex;
  flex-wrap: wrap;
  margin: calc(-1 * var(--gap)) 0 0 calc(-1 * var(--gap));
  width: calc(100% + var(--gap));
  padding: 0 1.5rem 1.5rem 0;

  .uploaded-file-wrapper {
    position: relative;;
    transition: box-shadow .25s,transform .25s;
    &:hover {

        transform: translateY(-0.4rem);
        box-shadow: 0 1.2rem 3rem rgba(26,30,42,.14);
        border: 0.1rem solid #dddddd;

      .uploaded-file--success {

        svg {

          opacity: 1;
        }
      }
    }

    padding: 1.5rem;
    //margin-right: 1.5rem;
    //margin-bottom: 1.5rem;
    margin: var(--gap) 0 0 var(--gap);
    &:last-child {
      margin-right: 0;
    }

    &:hover {
      background: #fff;
      transition: 0.5s;
      .uploaded-file-controls {
        opacity: 1;
      }
      .uploaded-file-error {
        opacity: 1;
      }
    }


    border: 0.1rem dashed #aaaaaa;
    border-radius: 0.5rem;

    display: flex;
    flex-direction: column;;
    align-items: flex-start;
    justify-content: space-between;

    .uploaded-file-controls {
      margin-top: 1rem;
      width: 100%;
      opacity: 0.4;
      transition: 0.3s;
      .btn {
        width: 100%;
      }
    }

    .uploaded-file-error {
      margin-top: 1rem;
      width: 100%;
      opacity: 0.4;
      transition: 0.3s;

      color: orangered;
    }
  }
  border-radius: 0.5rem;
  background: #f2f3f8;
}
.maxfiles-warning {
  padding: 0 0 1.5em 0;
  font-size: 0.9em;
}
</style>

<i18n>
{
  "en": {
    "upload": "Upload",
    "choose": "Upload file",
    "cancel": "Cancel",
    "Удалить": "Remove",
    "Ошибка": "Error",
    "Идет загрузка": "Loading",
    "Выбранные файлы": "Selected files",
    "files_uploaded_hint": "Maximum files: {max}, uploaded: {uploaded}."
  },
  "ru": {
    "upload": "Загрузить",
    "choose": "Добавить файл",
    "cancel": "Отмена",
    "files_uploaded_hint": "Максимальное количество файлов: {max}, загружено: {uploaded}."
  }
}
</i18n>
